import { Box } from '@mui/material';
import { PALETTE } from '@/styles/constants';

const tickBase = {
  position: 'absolute' as const,
  width: '18px',
  height: '18px',
  border: `1px solid ${PALETTE.goldSoft}`,
  opacity: 0.85,
  transition: 'width 0.3s ease, height 0.3s ease',
  zIndex: 3,
  '.aperture-root:hover &': {
    width: '24px',
    height: '24px',
  },
};

export default function ApertureHero() {
  return (
    <Box
      className="aperture-root"
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        background: PALETTE.parchmentDeep,
        padding: '18px',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          height: '100%',
          minHeight: '380px',
          overflow: 'hidden',
          border: '1px solid rgba(168, 129, 63, 0.45)',
          '&::after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            boxShadow: 'inset 0 0 60px rgba(13, 17, 10, 0.35)',
            background:
              'linear-gradient(180deg, rgba(13, 17, 10, 0.12) 0%, transparent 22%, transparent 72%, rgba(13, 17, 10, 0.4) 100%)',
            pointerEvents: 'none',
            zIndex: 2,
          },
        }}
      >
        <Box
          component="video"
          autoPlay
          muted
          loop
          playsInline
          src="/video/leap-hero-compressed.mp4"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
            filter: 'saturate(0.85) sepia(0.06) contrast(1.02)',
            transition: 'transform 1.4s cubic-bezier(0.2, 0.7, 0.2, 1)',
            '.aperture-root:hover &': {
              transform: 'scale(1.035)',
            },
          }}
        />
        <Box
          sx={{ ...tickBase, top: '10px', left: '10px', borderRight: 'none', borderBottom: 'none' }}
        />
        <Box
          sx={{ ...tickBase, top: '10px', right: '10px', borderLeft: 'none', borderBottom: 'none' }}
        />
        <Box
          sx={{ ...tickBase, bottom: '10px', left: '10px', borderRight: 'none', borderTop: 'none' }}
        />
        <Box
          sx={{ ...tickBase, bottom: '10px', right: '10px', borderLeft: 'none', borderTop: 'none' }}
        />
      </Box>
    </Box>
  );
}
